import axiosServices from './request';

const BlockChain = axiosServices('blockchain');

export default {
  /** 获取NFT信息 */
  getNftSceneInfo: BlockChain('get', 'nft/getNftSceneInfo'),
  /** 👿 (bind:1 触发绑定) - 获取NFT用户账户信息 (绑定NFT邮票) */
  getNftUserInfo: BlockChain('get', 'nft/getNftUserInfo'),
  /** 获取用户NFT收藏 */
  listUserNftAsset: BlockChain('get', 'nft/listUserNftAsset'),
  // 获取nft详情
  getChainNftInfo: BlockChain('get', 'nft/getChainNftInfo'),

  // 获取nft详情
  receiveChainNft: BlockChain('get', 'nft/receiveChainNft'),

  //生成NFT头像
  generateNftAvatar: BlockChain('post', 'nft/generateNftAvatar'),

  //获取NFT头像
  getNftAvatar: BlockChain('get', 'nft/getNftAvatar')

};
